import React from "react";
import { Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import { getBadgeTooltipConfig } from "./badgeTooltips";

const BadgeWithTooltip = ({ badgeType, badgeProps, children }) => {
  const config = getBadgeTooltipConfig(badgeType);

  if (!config) {
    // Fallback to regular badge if no tooltip config found
    return <Badge {...badgeProps}>{children}</Badge>;
  }

  return (
    <OverlayTrigger
      placement={config.placement}
      overlay={<Tooltip id={config.id}>{config.text}</Tooltip>}
    >
      <Badge {...badgeProps}>{children}</Badge>
    </OverlayTrigger>
  );
};

export default BadgeWithTooltip;
